import gql from 'graphql-tag';
const createChefPayout = gql`mutation addChefPayoutMethod($chefId: ID!,$payout: PayoutMethodInput!){
    addChefPayoutMethod(chefId:$chefId,payout:$payout)
}`
export default createChefPayout;
